const DROPDOWN_SELECTOR = ".header-desktop-navbar__dropdown";
const DROPDOWN_CONTENT_SELECTOR = ".header-desktop-navbar__dropdown-content";
const PROMO_WRAPPER_SELECTOR = "[data-promo-wrapper]";
const ROW_SELECTOR = ".header-desktop-navbar__row";
const ACTIVE_CLASS = "is-visible";
const TOGGLE_DELAY = 200;

function checkPromoVisibility(dropdownContent: HTMLElement) {
  const promo = dropdownContent.querySelector<HTMLElement>(PROMO_WRAPPER_SELECTOR);
  if (!promo) return;

  // If the promo is already hidden, avoid toggling its display in response to resize events.
  if (promo.style.display === "none") return;

  const row = dropdownContent.querySelector<HTMLElement>(ROW_SELECTOR);
  if (!row) return;

  promo.style.display = "";

  const rowRect = row.getBoundingClientRect();
  const promoRect = promo.getBoundingClientRect();

  if (promoRect.top > rowRect.top + 10) {
    promo.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const dropdownNodes =
    document.querySelectorAll<HTMLDivElement>(DROPDOWN_SELECTOR);

  const dropdowns = Array.from(dropdownNodes).map((root) => ({
    root,
    content: root.querySelector<HTMLDivElement>(DROPDOWN_CONTENT_SELECTOR)!,
  }));

  let openTimer: ReturnType<typeof setTimeout> | null = null;
  let closeTimer: ReturnType<typeof setTimeout> | null = null;

  const open = (item: (typeof dropdowns)[number]) => {
    openTimer = setTimeout(() => {
      if (item.root.matches(":hover") || item.content.matches(":hover")) {
        item.content.classList.add(ACTIVE_CLASS);
      }
    }, TOGGLE_DELAY);
  };

  const close = (item: (typeof dropdowns)[number]) => {
    closeTimer = setTimeout(() => {
      if (item.root.matches(":hover") || item.content.matches(":hover")) {
        clearTimeout(openTimer);
        return;
      }

      item.content.classList.remove(ACTIVE_CLASS);
      clearTimeout(closeTimer);
    }, TOGGLE_DELAY);
  };

  dropdowns.forEach((item) => {
    item.root.addEventListener("pointerenter", () => open(item));
    item.root.addEventListener("pointerleave", () => close(item));
  });

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const dropdownContent = entry.target as HTMLElement;
      if (dropdownContent.classList.contains(ACTIVE_CLASS) && entry.contentRect.height > 0) {
        checkPromoVisibility(dropdownContent);
      }
    });
  });

  dropdowns.forEach((item) => {
    resizeObserver.observe(item.content);
  });
});
